module.exports = __webpack_public_path__ + "static/media/1.50e54dcc.png";